import { InvoiceItemTaxIbsCbs } from '@/components/Fiscal/Invoice/InvoiceItemModal/PartFormsModal/InvoicePartForm.types';

export interface TaxReformEnableFlags {
  enableIbsCbsCredPres: boolean;
  enablePresumedCreditIbsZfm: boolean;
  enableTribRegular: boolean;
  enableGov: boolean;
  enableMono: boolean;
  enableAjusteCompet: boolean;
  enableCreditTransfersReversal: boolean;
}

const hasValue = (...values: unknown[]) =>
  values.some((value) => value !== undefined && value !== null);

/**
 * Deriva as flags `enable*` (checkboxes que exibem as seções da aba IBS/CBS)
 * a partir da presença de dados, para que seções preenchidas já abram
 * expandidas na edição do item.
 */
export function getTaxReformEnableFlags(
  ibsCbs?: InvoiceItemTaxIbsCbs,
): TaxReformEnableFlags {
  return {
    enableIbsCbsCredPres: hasValue(
      ibsCbs?.classificationCodePresumedCredit,
      ibsCbs?.ibsPresumedCreditPercentage,
      ibsCbs?.ibsPresumedCreditValue,
      ibsCbs?.ibsPresumedCreditSuspensiveConditionValue,
      ibsCbs?.cbsPresumedCreditPercentage,
      ibsCbs?.cbsPresumedCreditValue,
      ibsCbs?.cbsPresumedCreditSuspensiveConditionValue,
    ),
    enablePresumedCreditIbsZfm: hasValue(
      ibsCbs?.ibsZfmAssessmentPeriod,
      ibsCbs?.ibsZfmPresumedCreditType,
      ibsCbs?.ibsZfmPresumedCreditValue,
    ),
    enableTribRegular: hasValue(
      ibsCbs?.regularTaxIbsCbsCst,
      ibsCbs?.regularTaxIbsCbsClassificationCode,
      ibsCbs?.regularTaxIbsUfAliquotPercentage,
      ibsCbs?.regularTaxIbsUfValue,
      ibsCbs?.regularTaxIbsMunicipalAliquotPercentage,
      ibsCbs?.regularTaxIbsMunicipalValue,
      ibsCbs?.regularTaxCbsAliquotPercentage,
      ibsCbs?.regularTaxCbsValue,
    ),
    enableGov: hasValue(
      ibsCbs?.govPurchaseIbsUfAliquotPercentage,
      ibsCbs?.govPurchaseIbsUfValue,
      ibsCbs?.govPurchaseIbsMunicipalAliquotPercentage,
      ibsCbs?.govPurchaseIbsMunicipalValue,
      ibsCbs?.govPurchaseCbsAliquotPercentage,
      ibsCbs?.govPurchaseCbsValue,
    ),
    enableMono: hasValue(
      ibsCbs?.monoQuantity,
      ibsCbs?.monoAdRemIbsAliquotPercentage,
      ibsCbs?.monoAdRemCbsAliquotPercentage,
      ibsCbs?.monoIbsValue,
      ibsCbs?.monoCbsValue,
      ibsCbs?.monoRetentionQuantity,
      ibsCbs?.monoRetentionAdRemIbsAliquotPercentage,
      ibsCbs?.monoRetentionIbsValue,
      ibsCbs?.monoRetentionAdRemCbsAliquotPercentage,
      ibsCbs?.monoRetentionCbsValue,
      ibsCbs?.monoRetainedQuantity,
      ibsCbs?.monoRetainedAdRemIbsAliquotPercentage,
      ibsCbs?.monoRetainedIbsValue,
      ibsCbs?.monoRetainedAdRemCbsAliquotPercentage,
      ibsCbs?.monoRetainedCbsValue,
      ibsCbs?.monoDeferralIbsPercentage,
      ibsCbs?.monoDeferralIbsValue,
      ibsCbs?.monoDeferralCbsPercentage,
      ibsCbs?.monoDeferralCbsValue,
      ibsCbs?.monoItemIbsTotal,
      ibsCbs?.monoItemCbsTotal,
    ),
    enableAjusteCompet: hasValue(
      ibsCbs?.competenceApuration,
      ibsCbs?.competenceIbsValue,
      ibsCbs?.competenceCbsValue,
    ),
    enableCreditTransfersReversal: hasValue(
      ibsCbs?.creditTransferIbsValue,
      ibsCbs?.creditTransferCbsValue,
      ibsCbs?.creditReversalIbsValue,
      ibsCbs?.creditReversalCbsValue,
    ),
  };
}
